module.exports = __webpack_public_path__ + "media/images/flags/32/Jersey-42d9f564ab0250b9e9e0ac7c6112618e.png";